import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";

export default function InvestorSideNav({
  lang = {},
  currentLangFunc,
  currentDir,
  dirFormat = "ltr",
}) {
  const [openNav, setOpenNav] = useState(false);
  const [investorName, setInvestorName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const session = sessionStorage.getItem("aman-investor");
      if (session) {
        const parsed = JSON.parse(session);
        setInvestorName(parsed.user?.fullName || "Investor");
      }
    } catch (e) {}
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("aman-investor");
    navigate("/portal-login");
  };

  return (
    <>
      <div>
        <button
          onClick={() => setOpenNav(!openNav)}
          className="btn bg-white shadow position-fixed d-lg-none"
          style={{ top: "50px", zIndex: "50" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"></path>
          </svg>
        </button>
        {openNav && <div className="navBg"></div>}
        <aside
          id="sidebar"
          className={`sidebar ${openNav ? "active" : ""} ${
            dirFormat === "rtl" ? "sidebar-right" : "sidebar-left"
          }`}
        >
          <button
            className="btn position-absolute d-lg-none"
            style={{ top: "10px", right: "10px" }}
            onClick={() => setOpenNav(false)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path>
            </svg>
          </button>
          <NavLink to="/investor-panel" className="logo d-flex align-items-center">
            <img src="/img/logo.png" alt="logo" />
          </NavLink>

          <div className="w-100 text-center py-2 my-2 border-bottom">
            <h6 className="fw-bold mb-0 text-primary">{investorName}</h6>
            <span className="badge bg-light text-primary border mt-1">Investor Portal</span>
          </div>

          <ul className="sidebar-nav" id="sidebar-nav">
            <li className="nav-item">
              <NavLink
                className="nav-link collapsed"
                to="/investor-panel"
                end
                style={({ isActive }) => ({
                  color: isActive ? "#0F60FF" : "#000000",
                  background: isActive ? "#f6f9ff" : "",
                })}
              >
                <img src="/img/dashboard.png" alt="Dashboard" className="sidebaricon" />
                <span>{lang.Dashboard || "Dashboard"}</span>
              </NavLink>
            </li>

            <li className="nav-heading">Financial Reports & Data</li>

            <li className="nav-item">
              <NavLink
                className="nav-link collapsed"
                to="/investor-panel/transactions"
                style={({ isActive }) => ({
                  color: isActive ? "#0F60FF" : "#000000",
                  background: isActive ? "#f6f9ff" : "",
                })}
              >
                <i className="fa fa-money-bill-transfer sidebaricon"></i>
                <span>{lang.Transactions || "Transactions History"}</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className="nav-link collapsed"
                to="/investor-panel/statement"
                style={({ isActive }) => ({
                  color: isActive ? "#0F60FF" : "#000000",
                  background: isActive ? "#f6f9ff" : "",
                })}
              >
                <i className="fa fa-file-invoice-dollar sidebaricon"></i>
                <span>{lang.Statement || "Account Statement"}</span>
              </NavLink>
            </li>

            {/* <li className="nav-item">
              <NavLink
                className="nav-link collapsed"
                to="/investor-panel/pools"
                style={({ isActive }) => ({
                  color: isActive ? "#0F60FF" : "#000000",
                  background: isActive ? "#f6f9ff" : "",
                })}
              >
                <i className="fa fa-chart-pie sidebaricon fs-5 text-info"></i>
                <span>{lang.Pools || "Investment Pools"}</span>
              </NavLink>
            </li> */}

            <li className="nav-heading">Account Settings</li>

            <li className="nav-item">
              <NavLink
                className="nav-link collapsed"
                to="/investor-panel/profile"
                style={({ isActive }) => ({
                  color: isActive ? "#0F60FF" : "#000000",
                  background: isActive ? "#f6f9ff" : "",
                })}
              >
                <i className="fa fa-user-gear sidebaricon fs-5 text-secondary"></i>
                <span>{lang.Profile || "My Profile"}</span>
              </NavLink>
            </li>

            <li className="nav-item mt-4">
              <button
                className="nav-link collapsed w-100 text-start border-0 bg-transparent text-danger"
                onClick={handleLogout}
              >
                <i className="fa fa-right-from-bracket sidebaricon fs-5 text-danger"></i>
                <span>{lang.Logout || "Logout"}</span>
              </button>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
}
